import React, { useEffect, useState } from "react";

import usdc from "../../assets/images/homePage/USDC.svg";
import cross from "../../assets/images/homePage/x-mark.svg";
import refresh from "../../assets/images/overview/refresh.svg";
import logo from "../../assets/images/overview/overviewlogo.png";
import rightsign from "../../assets/images/overview/right_sign.png";
import erroricon from "../../assets/images/overview/error_icon.svg";
import updownarrow from "../../assets/images/overview/updownarrow.png";
import useTranslation from "../../Languages/Translation";

import { ethers } from "ethers";
import {
  useWeb3ModalAccount,
  useWeb3ModalProvider,
} from "@web3modal/ethers/react";
import {
  mintPiku,
  updateAllBalances,
  approveUSDT,
} from "../../Service/Web3/Web3Service";
import { useWeb3Context } from "../../Service/Web3/Web3Context";

function MintModal({ closeMintModel }) {
  const translation = useTranslation();

  const { walletProvider } = useWeb3ModalProvider();
  const { address, isConnected } = useWeb3ModalAccount();

  const [pay, setPay] = useState("");
  const [amount, setAmount] = useState("");
  const [isError, setError] = useState(false);
  const [formview, setformview] = useState(true);
  const [isLoading, setisLoading] = useState(true);
  const [pikuPrice, setPikuPrice] = useState(0);
  const [usdcBalance, setUSDCBalance] = useState(0);
  const [pikuBalance, setPikuBalance] = useState(0);
  const [transactionHash, setTransactionHash] = useState("");

  const { refreshPage } = useWeb3Context();
  const onsubmitForm = async (e) => {
    e?.preventDefault();

    const provider = new ethers.BrowserProvider(walletProvider);
    const signer = await provider.getSigner();
    if (Number(pay) > 0 && Number(amount) > 0 && Number(pay) < usdcBalance) {
      setisLoading(true);
      setformview(false);

      try {
        await approveUSDT(signer, pay);

        setTransactionHash(await mintPiku(signer, pay));
      } catch (e) {
        console.log(e);
        setError(true);
      }

      const { usdc_balance, piku_balance, piku_price } =
        await updateAllBalances(signer, address);

      setUSDCBalance(usdc_balance);
      setPikuBalance(piku_balance);
      setPikuPrice(piku_price);

      setisLoading(false);
      setformview(false);
      refreshPage();
    }
  };

  const load = async () => {
    const provider = new ethers.BrowserProvider(walletProvider);
    const signer = await provider.getSigner();
    const { usdc_balance, piku_balance, piku_price } = await updateAllBalances(
      signer,
      address
    );

    setUSDCBalance(usdc_balance);
    setPikuPrice(parseFloat(piku_price).toFixed(2));
  };

  useEffect(() => {
    if (isConnected && address && walletProvider) {
      load();
    }
  }, [isConnected, address, walletProvider]);

  return (
    <div className=" bg-black/85 fixed top-0 right-0 left-0 bottom-0 z-50">
      <div
        className={`bg-[#222222] px-[16px] lg:px-[32px] lg:max-h-[500px] xl:max-h-[700px] overflow-auto xl:overflow-visible ${
          !formview && "py-[32px]"
        } xl:py-[32px] w-full lg:w-[520px] ${
          !formview || !isLoading ? "min-h-auto" : "min-h-[500px]"
        } fixed rounded-t-[24px] lg:rounded-[24px] bottom-0 lg:bottom-auto lg:top-[50%] lg:left-[50%] transform lg:translate-x-[-50%] lg:translate-y-[-50%]`}
      >
        {/* Form Section */}
        <div
          onClick={() => {
            closeMintModel();
          }}
          className=" bg-[#383838] max-w-[32px] h-[5px]  mt-[10px] rounded-[4px] mx-auto lg:hidden"
        ></div>

        {!isError && formview && (
          <div className=" py-[10px] w-full bg-[#222222]  sticky top-[-5px] left-0 z-50 xl:hidden"></div>
        )}

        {!isError && formview && (
          <div>
            <div className=" flex items-center justify-between">
              <p className="text-[24px] lg:text-[32px] text-white aeonik_normal">
                {translation.Mint}
              </p>
              <img
                src={cross}
                onClick={() => closeMintModel()}
                alt="cross"
                className=" cursor-pointer hidden lg:block"
              ></img>
            </div>
            <p className="text-white aeonik_normal pt-[12px] lg:pt-[24px] pb-[24px] lg:pb-[32px] w-[90%]">
              {translation.Chooseamountandtokentomint}
            </p>
            <form onSubmit={onsubmitForm}>
              <div className="grid grid-cols-12 gap-x-[16px]">
                <div className=" col-span-12 flex flex-col">
                  <label className=" text-[#909090] aeonik_normal text-[14px] lg:text-[16px]">
                    Pay with
                  </label>
                  <div className=" relative">
                    <div className="absolute right-[0px] top-[28px] bg-[#1a1a1a] z-[10] px-[20px]">
                      <div className=" flex items-center  justify-end">
                        <img
                          className=" h-[24px] w-auto  object-contain"
                          src={usdc}
                          alt="mail"
                        />
                        <p className="text-[16px] aeonik_normal text-white ml-[4px] mr-[12px]">
                          USDC
                        </p>
                        <img src={updownarrow} alt="mail" />
                      </div>
                      <p
                        className="pt-[8px] text-[14px] aeonik_normal text-[#8d8d8d]"
                        onClick={() => {
                          setPay(Math.floor(usdcBalance * 100) / 100);
                          let amount = usdcBalance / pikuPrice;
                          setAmount(amount);
                        }}
                      >
                        {parseFloat(usdcBalance).toFixed(2)} USDC available
                      </p>
                    </div>
                    <input
                      value={pay}
                      type="number"
                      placeholder="0.00"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d*$/.test(value)) {
                          if (value === "") {
                            setPay("");
                            setAmount("");
                          } else {
                            const numericValue = parseFloat(value);
                            setPay(numericValue);
                            let amount = numericValue / pikuPrice;
                            setAmount(amount);
                          }
                        }
                      }}
                      className=" text-white bg-[#1a1a1a] w-full outline-none rounded-[8px] py-[30px] mt-[12px] placeholder:text-[#484848] pl-[20px] aeonik_normal"
                    ></input>
                  </div>
                </div>
                <div className="col-span-12  flex flex-col  pt-[16px]">
                  <label className=" text-[#909090] aeonik_normal text-[14px] lg:text-[16px]">
                    Amount
                  </label>
                  <div className="relative">
                    <img
                      className="absolute right-[0px] top-[22px] py-[10px] bg-[#1a1a1a] z-10 px-[20px]"
                      src={logo}
                      alt="mail"
                    />
                    <input
                      value={amount}
                      type="text"
                      // onChange={(e) =>
                      //   {
                      //     if (/^\d*\.?\d*$/.test(e.target.value)) {
                      //       setAmount(e.target.value?.trimStart());
                      //     }
                      //   }
                      // }
                      className="text-white w-full bg-[#1a1a1a] outline-none rounded-[8px] py-[22px] mt-[12px] placeholder:text-[#484848] pl-[20px] aeonik_normal"
                      placeholder="0.00"
                    />
                  </div>
                </div>
              </div>
              <p className=" text-white aeonik_medium text-[14px] pt-[16px] flex items-center">
                1 PIKU = {pikuPrice} USDC{" "}
                <img
                  src={refresh}
                  alt="refresh"
                  className=" cursor-pointer ml-[6px]"
                ></img>
              </p>
              <button
                type="submit"
                disabled={
                  Number(pay) === 0 &&
                  Number(amount) === 0 &&
                  Number(pay) > Number(usdcBalance)
                }
                className={`mt-[32px] w-full  ${
                  Number(pay) > 0 &&
                  Number(amount) > 0 &&
                  Number(pay) < Number(usdcBalance)
                    ? "bg-sky text-black"
                    : "bg-[#2E2E2E] text-[#808080]"
                } py-[10px] lg:py-[12px] px-[24px] rounded-[150px] aeonik_medium lg:text-[18px]`}
              >
                {Number(pay) > Number(usdcBalance)
                  ? "Insufficient USDC balance"
                  : "Continue"}
              </button>
            </form>
          </div>
        )}

        {/* Loader section */}

        {!isError && isLoading && !formview && (
          <div>
            <div className="rounded relative">
              <div className="rounded-full bg-[#223d40] w-[80px] h-[80px] relative flex justify-center items-center mx-auto animate-spin">
                <svg
                  className="absolute top-0 0 left-0"
                  width="80"
                  height="80"
                  viewBox="0 0 177 177"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M169.667 88.5C173.717 88.5 177.032 85.2113 176.696 81.1755C175.457 66.2542 170.448 51.8477 162.085 39.332C152.361 24.7783 138.539 13.435 122.367 6.73666C106.196 0.0383073 88.4018 -1.71429 71.2345 1.7005C54.0672 5.11529 38.298 13.5441 25.9211 25.921C13.5441 38.298 5.1153 54.0672 1.7005 71.2345C-1.71429 88.4018 0.0383044 106.196 6.73666 122.367C13.435 138.539 24.7783 152.361 39.332 162.085C51.8477 170.448 66.2542 175.457 81.1755 176.696C85.2113 177.032 88.5 173.717 88.5 169.667V169.667C88.5 165.618 85.2089 162.373 81.1792 161.971C69.1624 160.774 57.5826 156.642 47.4795 149.891C35.3374 141.778 25.8738 130.247 20.2855 116.755C14.6971 103.264 13.2349 88.4181 16.0838 74.0955C18.9328 59.773 25.9649 46.6168 36.2909 36.2908C46.6169 25.9649 59.773 18.9328 74.0955 16.0838C88.4181 13.2349 103.264 14.6971 116.755 20.2855C130.247 25.8739 141.778 35.3375 149.891 47.4795C156.642 57.5826 160.774 69.1624 161.971 81.1793C162.373 85.209 165.618 88.5 169.667 88.5V88.5Z"
                    fill="#26DDF9"
                  />
                </svg>
              </div>
            </div>
            <p className="pt-[24px] pb-[16px] text-center text-white text-[24px] lg:text-[32px] aeonik_medium">
              {translation.Waitingforconfirmations}
            </p>
            <p className="pb-[12px] text-center text-[#909090] aeonik_normal">
              {translation.Yourtransactionhasbeensent}
            </p>
            <p className="text-center text-[#909090] aeonik_normal">
              {translation.Confirmthistransactioninyourwallet}
            </p>
          </div>
        )}

        {/* Success section */}

        {!isError && !isLoading && !formview && (
          <div className=" text-center">
            <img
              src={rightsign}
              alt="right"
              className=" mx-auto mb-[24px]"
            ></img>
            <p className="pb-[12px] text-white aeonik_medium text-[24px] lg:text-[32px]">
              {translation.Youvesuccessfullyminted}
            </p>
            <p className="pb-[12px] text-[#909090] aeonik_normal">
              Your transaction has been confirmed on the blockchain. Piku is now
              available in your wallet.
            </p>

            <p className="pb-[10px] text-[#909090] aeonik_normal">
              {translation.YourTransactionHash}
            </p>
            <a
              href={"https://sepolia.etherscan.io/tx/" + transactionHash}
              className=" text-sky aeonik_normal"
            >
              {transactionHash
                ? `${transactionHash.substring(
                    0,
                    6
                  )}...${transactionHash.substring(transactionHash.length - 4)}`
                : ""}
            </a>
            <button
              onClick={() => closeMintModel()}
              className={`mt-[24px] lg:mt-[32px] w-full bg-sky text-black py-[10px] lg:py-[12px] px-[24px] rounded-[150px] aeonik_medium lg:text-[18px]`}
            >
              {translation.Close}
            </button>
          </div>
        )}

        {/* Error Modal section */}
        {isError && (
          <div className=" text-center">
            <img
              src={erroricon}
              alt="right"
              className=" mx-auto mb-[24px]"
            ></img>
            <p className="pb-[16px] text-white aeonik_medium text-[24px] lg:text-[32px]">
              Oops, looks like something <br /> went wrong!
            </p>
            <p className="text-[#909090] aeonik_normal">
              Sorry for the inconvenience. <br /> Please try again later or
              contact us.
            </p>
            <button
              onClick={() => closeMintModel()}
              className={`mt-[24px] lg:mt-[32px] w-full bg-sky text-black py-[10px] lg:py-[12px] px-[24px] rounded-[150px] aeonik_medium lg:text-[18px]`}
            >
              {translation.Close}
            </button>
          </div>
        )}

        {formview && (
          <div className=" py-[10px] w-full bg-[#222222]  sticky bottom-[-5px] left-0 z-50 xl:hidden"></div>
        )}
      </div>
    </div>
  );
}

export default MintModal;
